module.exports = __webpack_public_path__ + "static/media/END CAP 57 X 280 FOR SDS 300.8a899699.jpg";